export const AI_LOADING_GIF = "/images/ai-tagging/copilotloader.webp";
